import Permission from "./Permission";
import InventoryPermission from "./InventoryPermission";

export default Permission;
export { InventoryPermission };
